import { InjectionToken } from '@angular/core';

export interface AuthConfig {
  dashboard: string;
  onboarding: string;
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');
